module.exports = __webpack_public_path__ + "static/media/eva.089c4f4e.jpg";